import { type Loadable, initLoadable } from '@/loadingUtils'
import { type Stripe, type StripeElements } from '@stripe/stripe-js'
import { type Stripe as StripeNode } from 'stripe'

export type TStripeState = {
    payment: Loadable<{
        paymentMethods: StripeNode.PaymentMethod[]
        defaultPaymentMethod: StripeNode.PaymentMethod | null
    }>
    receipts: Loadable<StripeNode.PaymentIntent[]>
    stripe: Stripe | null
    elements: StripeElements | null
}

export const getInitialStripeState = (): TStripeState => {
    return {
        payment: initLoadable({
            paymentMethods: [],
            defaultPaymentMethod: null,
        }),
        receipts: initLoadable([]),
        stripe: null,
        elements: null,
    }
}

const moduleState = getInitialStripeState()

export default moduleState
